import React from 'react'
import "./search.css"
import bookdata from './bookdata';
import { useState } from 'react';

const Search = () => {
    const [filter,filterData]=useState('');
    const searchText=(e)=>{
      filterData(e.target.value)
    }
    const dataSearch1=bookdata.ai.filter(book=>{
      return Object.keys(book).some(key=>
        book[key].toString().toLowerCase().includes(filter.toString().toLowerCase())
        )
    })
    const dataSearch2=bookdata.clanguage.filter(book=>{
    return Object.keys(book).some(key=>
      book[key].toString().toLowerCase().includes(filter.toString().toLowerCase())
      )
  })
  const dataSearch3=bookdata.cpp.filter(book=>{
    return Object.keys(book).some(key=>
      book[key].toString().toLowerCase().includes(filter.toString().toLowerCase())
      )
  })
  const dataSearch4=bookdata.csharp.filter(book=>{
    return Object.keys(book).some(key=>
      book[key].toString().toLowerCase().includes(filter.toString().toLowerCase())
      )
  })

  const dataSearch=dataSearch1.concat(dataSearch2,dataSearch3,dataSearch4);
  


  return (
    <>
  <div className='sasura'>
  <input
      type='text'
      className='inputwa'
      value={filter}
      onChange={searchText.bind(this)}
      placeholder='search book or author'
      />
  </div>
  <section className="main-section">

  {dataSearch.map((book) =>{
            return(
              <div className="card">
              <img
                className="image"
                src={book.img}
                alt=""
              />
              <h5 style={{ textAlign: "center",padding:10 }}>
                {book.title}
              </h5>
              <h6 style={{ textAlign: "center" }}>
                {book.author}
              </h6>
            </div>
                  )
                }
  )
              }

    
    
    
  </section>
</>

  )
}

export default Search